// Main entry point for frontend scripts
// Import and initialize modules

// Import GSAP first
import { gsap } from "gsap";

import { SlowMo } from "gsap/EasePack";

import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, SplitText);

const smoother = ScrollSmoother.create({
  smooth: 1,
  effects: true,
  normalizeScroll: true,
});

// Handle initial page load with hash
if (window.location.hash) {
  // Scroll to top immediately to prevent browser's default jump
  window.scrollTo(0, 0);

  // Wait for splash screen to complete before scrolling to hash
  const scrollToHash = () => {
    const hash = window.location.hash;
    const targetElement = document.querySelector(hash);

    if (targetElement && smoother) {
      // Small delay to ensure everything is initialized
      setTimeout(() => {
        smoother.scrollTo(targetElement, true, "top 100px");
      }, 100);
    }
  };

  // Listen for splash screen completion event
  document.addEventListener('splashScreenComplete', scrollToHash, { once: true });

  // Fallback in case splash screen is disabled or doesn't fire
  window.addEventListener('load', () => {
    setTimeout(() => {
      // Only scroll if splash hasn't already triggered it
      if (window.location.hash) {
        scrollToHash();
      }
    }, 1000);
  });
}

// Global handler for smooth scrolling to anchor links
document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  const link = target.closest('a[href]') as HTMLAnchorElement;

  if (link && link.hash) {
    // Parse the link to check if it's a same-page anchor (with or without pathname)
    const linkUrl = new URL(link.href, window.location.origin);
    const currentUrl = new URL(window.location.href);

    // Only handle if it's the same page (pathname matches) and has a hash
    if (linkUrl.pathname === currentUrl.pathname && link.hash) {
      const targetElement = document.querySelector(link.hash);
      if (targetElement) {
        e.preventDefault();

        // Use ScrollSmoother's scrollTo method for smooth anchor scrolling
        if (smoother) {
          smoother.scrollTo(targetElement, true, "top 100px"); // true = smooth, offset for fixed header
        }
      }
    }
  }
});

// Import splash screen module (will auto-initialize)
import "./components/splashscreen/splash-screen";

import "./components/articlehero/article-hero";

import "./components/footer/footer";

import "./components/scrolltext/scroll-text";
import "./components/timeline/timeline";
import "./components/newsTimeline/newsTimeline";
import "./components/blockquote/blockquote";
import "./components/splitbutton/splitbutton";
import "./components/blockLargeText/blockLargeText";
import "./components/blockReadMore/blockReadMore";
import "./components/blockStartContact/blockStartContact";
import "./components/contactForm/contactForm";
import "./components/starthero/start-hero";
import "./components/dropdown/dropdown";
import "./components/header/sticky-header";
import "./components/header/logo-hover";
import "./components/header/mobile-menu";
import "./components/blockMedia/blockMedia";

// Make GSAP available globally if needed
window.gsap = gsap;


